import React from 'react';
import { DotProps } from 'recharts';
import { ChartData } from './helper';

interface CustomDotsProps extends DotProps {
  chartTrends: ChartData[];
  dataKey: string;
  index?: number;
  color: string;
}

const CustomDot: React.FC<CustomDotsProps> = props => {
  const { cx, cy, index, chartTrends, dataKey, color } = props;
  if (index === undefined) return null;
  const isCurrentNull = chartTrends[index][dataKey] === 'null';
  const isPrevNull = index > 0 && chartTrends[index - 1][dataKey] === 'null';
  const isNextNull =
    index < chartTrends.length - 1 &&
    chartTrends[index + 1][dataKey] === 'null';

  if (!isCurrentNull && (isPrevNull || isNextNull)) {
    return <circle cx={cx} cy={cy} r={2} fill={color} />;
  }
  return null;
};

export default CustomDot;
